var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toolbar',{ref:"toolbar",staticClass:"table-toolbar",attrs:{"hidden":!_vm.editor || !_vm.active,"position":_vm.position,"buttons":[
    [
      {
        text: _vm.$t('Row'),
        menu: [
          { text: 'Insert Before', icon: 'el-icon-fa-arrow-to-top', click: function () { return _vm.editor.insertTableRow('before'); } },
          { text: 'Insert After', icon: 'el-icon-fa-arrow-to-bottom', click: function () { return _vm.editor.insertTableRow('after'); } },
          { text: 'Delete', icon: 'el-icon-fa-trash', click: function () { return _vm.editor.deleteTableRow(); }, divided: true }
        ]
      },
      {
        text: _vm.$t('Column'),
        menu: [
          { text: 'Insert Before', icon: 'el-icon-fa-arrow-to-left', click: function () { return _vm.editor.insertTableColumn('before'); } },
          { text: 'Insert After', icon: 'el-icon-fa-arrow-to-right', click: function () { return _vm.editor.insertTableColumn('after'); } },
          { text: 'Delete', icon: 'el-icon-fa-trash', click: function () { return _vm.editor.deleteTableColumn(); }, divided: true }
        ]
      },
      {
        text: _vm.$t('Cell'),
        menu: [
          { text: 'Toggle Headers', click: function () { return _vm.editor.toggleTableHeadersCells(); } },
          { text: 'Merge Cells', click: function () { return _vm.editor.mergeTableCells(); }, divided: true },
          { text: 'Split Cells', click: function () { return _vm.editor.splitTableCells(); } }
        ]
      },
      { icon: 'el-icon-fa-trash', title: _vm.$t('Delete'), click: function () { return _vm.deleteTable(); } }
    ]
  ]}})}
var staticRenderFns = []

export { render, staticRenderFns }